import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["settingsButton", "senderMatchInput"]

  connect() {
    this.updateSenderMatchIndicator()
  }

  disconnect() {
  }

  updateSenderMatchIndicator() {
    if (!this.hasSettingsButtonTarget || !this.hasSenderMatchInputTarget) return

    this.settingsButtonTarget.classList.toggle("text-brand-accent", this.senderMatchInputTarget.checked)
    this.settingsButtonTarget.classList.toggle("text-ink-soft", !this.senderMatchInputTarget.checked)
  }

  remove(event) {
    this.element.remove()
    event.preventDefault();
    return false;
  }
}
